import { Box, Grid2, Typography, useMediaQuery, useTheme } from "@mui/material";
import { BizboxLogo } from "../../../common/components/bizbox-logo";
import { ChangeEmailForm } from "./otp-form";
import { BeaconLogo } from "../../../common/components/beacon-logo";

const OTPPage: React.FC = () => {
  const theme = useTheme();
  const isLaptop = useMediaQuery(theme.breakpoints.up("laptop"));

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "background.default",
        overflow: "hidden",
        overflowY: "auto",
      }}
    >
      {isLaptop && (
        <Box
          sx={{
            height: "25%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "47px",
              height: "47px",
              m: 0,
              p: 0,
              display: "block",
            }}
          >
            <BizboxLogo />
          </Box>
          <Box
            sx={{
              height: "25%",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BeaconLogo />
          </Box>
        </Box>
      )}

      <Grid2
        container
        sx={{
          height: { mobile: 12, laptop: "633px" },
          width: { mobile: "100%", tablet: "90%" },
          boxShadow: 2,
          borderRadius: "12px",
        }}
      >
        <Grid2
          size={{ mobile: 12, tablet: 12, laptop: 6 }}
          sx={{
            backgroundColor: "#EAF5FE",
            height: { mobile: "100vh", laptop: "100%" },
            display: "flex",
            flexDirection: "column",
            padding: 4,
          }}
        >
          <Typography
            color="primary.main"
            fontWeight={500}
            align="left"
            sx={{
              whiteSpace: "nowrap",
              mb: 1,
            }}
          >
            One Time Pin Required
          </Typography>

          <Typography
            fontSize={12}
            fontWeight={300}
            align="left"
            sx={{ mb: "5px" }}
            color="text.secondary"
          >
            Enter the PIN sent to your email to continue
          </Typography>

          <img
            src="/carousel/otp.svg"
            alt="Create New Password"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Grid2>

        <Grid2
          size={{ mobile: 12, tablet: 12, laptop: 6 }}
          sx={{
            height: { mobile: "100vh", laptop: "100%" },
          }}
        >
          <ChangeEmailForm />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default OTPPage;
